import { Controller } from "@hotwired/stimulus";
import { buildChartConfig } from "../service_report_chart_config";

// Renders a ServiceReport chart block into a <canvas> using the shared chart-config builder.
// Chart is a global (chartjs/chart.umd.min, loaded by the layout).
export default class extends Controller {
  static targets = ["canvas"];
  static values = { spec: Object, colors: Array };

  connect() {
    this.createChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  createChart() {
    if (this.chart) return;
    const config = buildChartConfig(this.specValue, this.colorsValue);
    this.chart = new Chart(this.canvasTarget, config);
  }
}
